import { useQuery } from "@tanstack/react-query";

import { customFetch } from "../util/customFetch";

export function useApiManagerList({ enabled = true, params }) {
  const page = params.page || params.firstResult;
  const size = params.size || params.maxResults;
  const sortOrder = params.sortOrder || "desc";
  const sort = params.sortBy
    ? `${params.sortBy},${sortOrder}`
    : params.sort
      ? `${params.sort},${sortOrder}`
      : "";

  const queryParams = { page, size, sortOrder, sort };
  return useQuery({
    enabled,
    queryKey: ["api-manager", queryParams],
    queryFn: async () =>
      customFetch(
        `/api/smartbpm/v1/{tenant}/api_manager?${new URLSearchParams(queryParams)}`,
      ),
  });
}
